<template>
  
  <div id="left-side">
      <div class="mframe">
        <div class="total">
            <div class="frame">
              <p class="titillium-sb" data-value="฿"><i class="titillium-r">{{ text.amountToPaid }}</i>  {{ total.split('.')[0] }}<font>.{{ total.split('.')[1] }}</font></p>
              <div class="details">
                  <div class="paid">
                    <label class="titillium-r">{{ text.paid }}</label>
                    <p class="titillium-sb">{{ amountPaid }}</p>
                  </div>
                  <div class="balance">
                    <label class="titillium-r">{{ text.balance }}</label>
                    <p class="titillium-sb">{{ outstanding }}</p>
                  </div>
              </div>
            </div>
        </div>

        <div class="info">  

            <div v-if="files.length" class="row files">
              <div class="col-6">
                    <label class="titillium-r">{{ text.attachedFile }}</label>
              </div> 
              <div class="col-6">
                    <p v-for="(file, index) in files" :key="index"><img src="../assets/document.svg" /> &nbsp;  <a :href="s3 + file.filePath" target="_blank" class="cut-text-1">{{ file.fileName+file.fileName+file.fileName }}</a></p>
              </div> 
            </div> 

            <div class="remark titillium-r">{{ text.payInDate }}</div>
            <div class="date-time">
              <span>
                  <p class="date titillium-sb">{{ expireDateTime[0] }}</p>
                  <p class="time titillium-sb">{{ expireDateTime[1] }}</p>
              </span>
            </div>
            <div class="id-name">
              <div class="name">
                  <label class="titillium-r">{{ text.name }}</label>
                  <p class="titillium-sb">{{ custname }}</p>
              </div>
              <div class="id">
                  <label class="titillium-r">{{ text.hn }}</label>
                  <p class="titillium-sb">{{ ref1 }}</p>
              </div>
            </div>
            <a href="javascript:;" @click="OpenAccordionInfo" class="arrow_expense_down btn-list clickslide titillium-sb">{{ text.payDetail }} <em class="icon_select_down"></em></a>
            <a href="javascript:;" @click="CloseAccordionInfo" class="arrow_expense_up btn-list clickslide titillium-sb" style="display: none;">{{ text.payDetail }} <em class="icon_select_up"></em></a>
        </div>
 
        <div class="list">
            <section>
              <figure>
                  <span>
                    <p class="topic titillium-sb" style="padding-right: 5px;">{{ text.payDetailList }}</p>
                    <p class="amount titillium-sb" style="padding-right: 5px;"> {{ text.payDetailAmount }}</p>
                    <p class="discount titillium-sb" style="padding-right: 5px;">{{ text.payDetailDiscount }}</p>
                    <p class="net titillium-sb">{{ text.payDetailNet }}</p>
                  </span>
              </figure>
              <figure class="all">
                  <em class=""></em>
                  <span>
                    <p class="topic titillium-r">{{ text.summary }} &nbsp;</p>
                    <p class="amount titillium-sb">{{ toDigit(summary.price) }} &nbsp;</p>
                    <p class="discount titillium-sb">{{ toDigit(summary.discount) }} &nbsp;</p>
                    <p class="net titillium-sb">{{ toDigit(summary.amount) }}</p>
                  </span>
              </figure>

              <figure v-for="(res,k) in invoice" :key="k" class="de">     
                <template v-if="res.billing_group_desc != ''">             
                  <a class="htopic titillium-r" data-fancybox :data-src="'#list'+k" href="javascript:;">
                    <em class="icon arrow"></em>
                    <p> {{ res.billing_group_desc }}</p>
                  </a>
                </template> 
                <template v-else>
                  <figure v-for="(rr,kk) in res.sub" :key="kk" class="de">                  
                      <a class="htopic titillium-r" data-fancybox :data-src="'#list_nosub'+kk" href="javascript:;">
                        <em class="icon arrow"></em>
                        <p> {{ rr.description }} </p>
                      </a>
                  </figure> 
                </template>
              </figure>   
            </section>                                          
        </div>

        <!-- POPUP -->
        <div v-for="(res,k) in invoice" :key="k" class="popup" :id="'list'+k" >
            <figure>
              <span>
                  <p class="topic titillium-sb" style="padding-right: 5px;">{{ text.payDetailList }}</p>
                  <p class="amount titillium-sb" style="padding-right: 5px;"> {{ text.payDetailAmount }}</p>
                  <p class="discount titillium-sb" style="padding-right: 5px;">{{ text.payDetailDiscount }}</p>
                  <p class="net titillium-sb">{{ text.payDetailNet }}</p>
              </span>
            </figure>
            <figure>
              <div v-for="(rr,kk) in res.sub" :key="kk" class="content">           
                  <div class="htopic titillium-r">{{ rr.description }}</div>
                  <span>
                    <p class="topic sub titillium-r"><span v-if="rr.order_item">{{ '- '+rr.order_item }}</span> &nbsp;</p>
                    <p class="amount titillium-r">{{ toDigit(rr.price) }} </p>
                    <p class="discount titillium-r">{{ toDigit(rr.discount)}} </p>
                    <p class="net titillium-sb">{{ toDigit(rr.amount) }} </p>
                  </span>
              </div>                  
            </figure>
        </div>  
        <!-- POPUP แบบ no billing subgroup -->
        <div v-for="(res,k) in sub_no_group.sub" :key="k" class="popup" :id="'list_nosub'+k" >
            <figure>
              <span>
                  <p class="topic titillium-sb" style="padding-right: 5px;">{{ text.payDetailList }}</p>
                  <p class="amount titillium-sb" style="padding-right: 5px;"> {{ text.payDetailAmount }}</p>
                  <p class="discount titillium-sb" style="padding-right: 5px;">{{ text.payDetailDiscount }}</p>
                  <p class="net titillium-sb">{{ text.payDetailNet }}</p>
              </span>
            </figure>
            <figure>
              <div class="content">           
                  <span>
                    <p class="topic sub titillium-r">{{ res.description }} </p>
                    <p class="amount titillium-r">{{ toDigit(res.price) }} </p>
                    <p class="discount titillium-r">{{ toDigit(res.discount)}} </p>
                    <p class="net titillium-sb">{{ toDigit(res.amount) }} </p>
                  </span>
              </div>                  
            </figure>
        </div>  
 
    </div>
  </div>
 
</template>

<script> 
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default {
  data() {
    return { 
      summary: {
        amount : 0,
        discount : 0,
        price : 0,
      },
      s3: this.$store.state.s3,
      sub_no_group : {
          billing_group_code:'xxx',
          billing_group_desc:'',
          sub:[]
        }
    }
  },
  created(){
    Fancybox.bind('[data-fancybox]', {
      on: {
         "*": (fancybox, eventName) => {
            if (eventName == 'done') {
               $('main').addClass('main_blue');  
               console.log('done')
            }
            if (eventName == 'destroy') {
               $('main').removeClass('main_blue');   
               console.log('destroy')
            }
         },
      }
    });
  },
  methods: {  
    OpenAccordionInfo(){
      $("#left-side section").slideToggle( "slow", function() {
      });
      $('.arrow_expense_down').hide();  
      $('.arrow_expense_up').show();  
    },
    CloseAccordionInfo(){
      $("#left-side section").slideToggle( "slow", function() {
      });
      $('.arrow_expense_down').show();
      $('.arrow_expense_up').hide();  
    },
    toDigit(num) {   
      if(num > 0){
        return this.twoDecimal(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return '0.00'
    }, 
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    },
  },
  computed: { 
    text() {
      let obj = {}
      if (this.$store.state.language == 'TH') {
        obj = {
          amountToPaid: 'ยอดรวม',
          paid: 'ชำระแล้ว',
          balance: 'ยอดคงเหลือ',
          attachedFile: 'เอกสารแนบ :',
          payInDate: 'กรุณาชำระเงินภายในวัน-เวลา',
          name: 'ชื่อ-นามสกุล :',
          hn: 'เลขประจำตัวผู้ป่วย :', 
          payDetail: 'แสดงรายละเอียดค่ารักษาพยาบาล', 
          payDetailNotFount: 'ไม่พบรายละเอียดค่ารักษาพยาบาล', 
          payDetailList: 'รายการ', 
          payDetailAmount: 'จำนวนเงิน', 
          payDetailDiscount: 'ส่วนลด', 
          payDetailNet: 'ยอดสุทธิ', 
          paymentType: 'เลือกวิธีการชำระเงิน', 
          nextButton: 'ดำเนินการต่อ',
          linkExp: 'ลิงค์ชำระเงินนี้หมดอายุแล้ว',
          expireDateTime: this.$store.state.expireDateTimeTh,
          summary: 'รวม',
          nosumgroup: 'รายละเอียดค่ารักษาพยาบาล',
        }
      } else {
        obj = {
          amountToPaid: 'Total',
          paid: 'Paid',
          balance: 'Balance',
          attachedFile: 'Attached document(s) :',
          payInDate: ' Please pay in full before :',
          name: 'Name :',
          hn: 'HN :', 
          payDetail: 'Show medical expense details', 
          payDetailNotFount: 'Not Found details of medical expenses', 
          payDetailList: 'List', 
          payDetailAmount: 'Amount', 
          payDetailDiscount: 'Discount', 
          payDetailNet: 'Net', 
          paymentType: 'Payment Type', 
          nextButton: 'Next',
          linkExp: 'This link expire.',
          expireDateTime: this.$store.state.expireDateTimeEn,
          summary: 'Total',
          nosumgroup: 'medical expense details',
        }
      }
      return obj
    },
    custname() {
        return this.$store.state.name
    }, 
    total() {  
        return this.twoDecimal(this.$store.state.total)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },     
    amountPaid() { 
      return this.twoDecimal(this.$store.state.total - this.$store.state.outstanding)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    outstanding() {
      // return this.$store.state.outstanding
      return this.twoDecimal(this.$store.state.outstanding)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }, 
    ref1() {
      return this.$store.state.ref1
    }, 
    expireDateTime() {
      var x = ''
      if (this.$store.state.language == 'TH') {
         x = this.$store.state.expireDateTimeTh.split('เวลา')
      }else{
         x = this.$store.state.expireDateTimeEn.split('-')
      }
      return x
    },   
    files() {
      if (!this.$store.state.files) return []
      return this.$store.state.files
    },
    invoice() {
      try {
        this.summary = {
          amount : 0,
          discount : 0,
          price : 0,
        }  
          var temp_inv = Object.values(this.$store.state.invoicedesc).map((res) => {
            if (this.$store.state.language == 'TH') {
              res.billing_group_desc = res.billing_group_desc_th
              res.description = res.description_th
            }else{
              res.billing_group_desc = res.billing_group_desc_en
              res.description = res.description_en
            }
            this.summary.price += parseFloat(res.price)
            this.summary.discount += parseFloat(res.discount)
            this.summary.amount += parseFloat(res.amount)
            return res
          })  

        var inv = []
        var group = []
        var group_key = []
        var sub = []
        this.sub_no_group = {
          billing_group_code:'xxx',
          billing_group_desc:'',
          sub:[]
        }

        for (let index = 0; index < temp_inv.length; index++) {
          const element = temp_inv[index];
          if (element.billing_group_code) {
            if(!group_key.includes(element.billing_group_code)){
              group_key.push(element.billing_group_code)
              group.push({
                billing_group_code:element.billing_group_code,
                billing_group_desc:element.billing_group_desc,
                sub:[]
              })
            }
            sub.push(element)
          }else{ 
            this.sub_no_group.sub.push(element)
          }
        }

          for (let i = 0; i < group.length; i++) {
            const element = group[i];
              for (let index = 0; index < sub.length; index++) {
                  const el = sub[index];
                  if(element.billing_group_code === el.billing_group_code){
                    element.sub.push(el)
                  }
              }
              inv.push(element)
          } 

        if(this.sub_no_group.sub.length) inv.push(this.sub_no_group) 
        return inv
      } catch (error) {
        // 
      } 
    },
  }, 
}
</script> 
<style scoped>
.info {
  background-color: #fff !important;
  border-color: #fff !important;
}

</style>